import { type AxiosResponse } from 'axios'
import { type AxiosOptions } from 'shared/api'
import { baseApi } from 'entities/Auth'

import { type IResponseInbox } from 'entities/Inbox/api/types'
import type {
  IRcsUpdateParams,
  IResponseRcs,
  IRcsUploadLogoParams,
  IResponseRcsUploadLogo,
  IRcsRemoveLogoParams,
  IResponseRcsRemoveLogo,
  IRcsUploadBannerParams,
  IResponseRcsUploadBanner,
  IRcsRemoveBannerParams,
  IResponseRcsRemoveBanner,
  IRcsParams,
  IResponseRcsFallbackInbox,
} from './types'

class Api {
  updateRcs(params: IRcsUpdateParams): Promise<AxiosResponse<IResponseRcsFallbackInbox>> {
    return baseApi.post(`rcs-sender/${params.id}/fallback-inbox`, params)
  }

  getRcs(options?: AxiosOptions): Promise<AxiosResponse<IResponseRcs[]>> {
    return baseApi.get('rcs-sender/list', { ...options })
  }

  getRcsOrganizationInbox(options?: AxiosOptions): Promise<AxiosResponse<IResponseInbox[]>> {
    return baseApi.get('rcs-sender/inboxes', { ...options })
  }

  uploadLogo(params: IRcsUploadLogoParams): Promise<AxiosResponse<IResponseRcsUploadLogo>> {
    return baseApi.post('rcs-sender/logo', params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  removeLogo(params: IRcsRemoveLogoParams): Promise<AxiosResponse<IResponseRcsRemoveLogo>> {
    return baseApi.delete('rcs-sender/logo', { params })
  }

  uploadBanner(params: IRcsUploadBannerParams): Promise<AxiosResponse<IResponseRcsUploadBanner>> {
    return baseApi.post('rcs-sender/banner', params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  removeBanner(params: IRcsRemoveBannerParams): Promise<AxiosResponse<IResponseRcsRemoveBanner>> {
    return baseApi.delete('rcs-sender/banner', { params })
  }

  saveRcs(params: IRcsParams): Promise<AxiosResponse<IResponseRcs>> {
    return baseApi.post('rcs-sender/save', params)
  }
}

export const RcsApi = new Api()
